<div class="aprova-radio-group" [class.aprova-radio-group--disabled]="disabled">
  @if (label) {
  <div class="aprova-radio-group__label-box">
    <label
      [for]="id"
      [class]="labelClass"
    >
      {{ label }}
    </label>

    @if (optionalTag) {
    <span class="aprova-radio-group__optional-tag">(opcional)</span>
    }
  </div>
  }

  <div
    class="aprova-radio-group__options"
    [class.aprova-radio-group__options--vertical]="vertical"
  >
    @for(option of radioOptions; track option.value) {
    <aprova-radio
      [label]="option.label || option.value"
      [name]="name"
      [value]="option.value"
      [control]="control"
      [disabled]="option.disabled || disabled"
      [checked]="control.value === option.value"
      (onChange)="onValueChange($event)"
    />
    }
  </div>
</div>
